// src/admin/components/task/ReportSection.jsx
import React from 'react';

export default function ReportSection({ stepKey, formId, fields }) {
  const fieldNames = Object.keys(fields);

  const renderValue = value => {
    if (value === true) return 'Yes';
    if (value === false) return 'No';
    if (value === '' || value == null) return <span className="text-muted fst-italic">No data provided</span>;
    
    // Handle nested objects
    if (typeof value === 'object' && value !== null) {
      return (
        <div>
          {Object.entries(value).map(([key, val]) => (
            <div key={key} className="mb-1">
              <span className="text-muted small">{key}: </span>
              <span className="fw-semibold">{renderValue(val)}</span>
            </div>
          ))}
        </div>
      );
    }
    
    return value;
  };

  return (
    <div className="border rounded p-4 mb-4">
      <h6 className="fw-semibold mb-2">Step: {stepKey}</h6>
      <div className="text-muted small mb-3">Form: {formId}</div>
      <div className="row">
        {fieldNames.map(field => (
          <div className="col-md-6 mb-3" key={field}>
            <div className="text-muted small">{field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}</div>
            <div className="fw-semibold">{renderValue(fields[field])}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
